/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { LogLevel } from '@azure/msal-browser';

const urlParams = new URLSearchParams(window.location.search);
const realmKey = urlParams.get('realmKey');
const runTime = urlParams.get('runTime') || 'dev';
const clientId = realmKey?.trim() || `${window['env'].CLIENT_ID}`;
const postLogoutRedirectUri = window.location.origin || `${window['env'].REDIRECT_URI}`;
const redirectUri = window.location.origin || `${window['env'].REDIRECT_URI}`;
const scopes = (window['env'].GRAVITEE_DEFAULT_SCOPE || '').split(',');
const authorityMetadata = getDynamicMetadata(realmKey, runTime) || window['env'].MSAL_AUTHORITY_METADATA;
const msalLogLevel = window['env'].MSAL_LOG_LEVEL as string;

const authority =
  getDynamicAuthority(realmKey, runTime) ||
  window['env'].AUTHORITY_ADDRESS ||
  `https://${window['env'].B2C_DOMAIN_HOST}/${window['env'].TENANT_HOST}/${window['env'].POLICY_NAME}`;
// @ts-ignore
const loggingLevel = LogLevel[msalLogLevel];
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-ignore
const getLoggerCallback = () => {
  return (level: LogLevel, message: string, containsPii: boolean) => {
    if (containsPii) {
      return;
    }
    switch (level) {
      case LogLevel.Error:
        console.error(message);
        return;
      case LogLevel.Info:
        console.info(message);
        return;
      case LogLevel.Verbose:
        console.debug(message);
        return;
      case LogLevel.Warning:
        console.warn(message);
        return;
    }
  };
};

const msalProviderConfig = {
  type: 'popup',
  msalConfig: {
    auth: {
      clientId,
      authority,
      authorityMetadata,
      knownAuthorities: [authority],
      redirectUri,
      postLogoutRedirectUri,
      protocol: 'OIDC',
      responseType: 'idToken'
    },
    cache: {
      cacheLocation: 'localStorage'
    },
    system: {
      loggerOptions: {
        loggerCallback: getLoggerCallback(),
        logLevel: loggingLevel
      }
    }
  },
  silentRequestConfig: {
    scopes: [...scopes]
  },
  endSessionRequestConfig: {},
  loginRequestConfig: {
    scopes: [...scopes]
  }
};
function getDynamicMetadata(realmKey: string | null, runTime: string | null) {
  if (!realmKey) {
    return undefined;
  }
  if (runTime) {
    console.warn(`runtime ${runTime} environment detected`);
  }
  console.log('Realm Key:', realmKey);
  let metadata = window['env'].MSAL_AUTHORITY_METADATA;
  metadata = JSON.stringify(metadata);
  if (runTime === 'dev' || runTime === 'interop' || runTime === 'psr') {
    metadata = metadata.replaceAll('byiam-dev15', clientId).replaceAll('auth.dev', `auth.${runTime}`);
  } else {
    metadata = metadata
      .replaceAll('byiam-dev15', clientId)
      .replaceAll('auth.dev.na.blueyonder.dev', `auth.${runTime}.blueyonder.inc`);
  }
  metadata = JSON.parse(metadata);

  return metadata;
}
function getDynamicAuthority(realmKey: string | null, runTime: string | null) {
  if (!realmKey) {
    return undefined;
  }
  if (runTime) {
    console.warn(`runtime ${runTime} environment detected`);
  }
  let authority = window['env'].AUTHORITY_ADDRESS;
  if (runTime === 'dev' || runTime === 'interop' || runTime === 'psr') {
    authority = authority.replaceAll('byiam-dev15', clientId).replaceAll('auth.dev', `auth.${runTime}`);
  } else {
    authority = authority
      .replaceAll('byiam-dev15', clientId)
      .replaceAll('auth.dev.na.blueyonder.dev', `auth.${runTime}.blueyonder.inc`);
  }
  return authority;
}
export { msalProviderConfig };
